import {Directive, HostListener, Input} from '@angular/core';

declare var jQuery:any;

@Directive({
  selector: `[scrollSpy]`
})
export class ScrollSpyDirective {

  @Input() scrollSpy: string;

  // Capture click event on element
  @HostListener('click', ['$event'])
  onMouseClick(event: Event) {

    //Scroll target element
    const target = jQuery(this.scrollSpy);
    console.log('Hello ' + target.offset());
    // Scrolling delay
    const scrollDelay = 1000;

    // Scroll with jQuery
    if (target.offset()) {
      jQuery('html, body').animate({
        scrollTop: target.offset().top
      }, scrollDelay);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/scroll-spy.directive.ts